export enum OrderState {
  All = 0,
  Deleted = 102,
  Initial = 8001,
  AllNew = 8103,
  New = 8002,
  Canceled = 8009,
  Confirmed = 8005,
  Rejected = 8006,
  AllCanceled = 8104,
  PickupPointArrive = 8010,
  PickupPointArriveConfirmed = 8011,
  Loading = 8012,
  PickupOnTheWay = 8013,
  LoadingRefused = 8014,
  CancelWithinPickup = 8015,
  LoadingRejected = 8016,
  HalfWayArrived = 8017,
  HalfWayArrivedConfirm = 8018,
  HalfWayDownLoading = 8019,
  HalfWayDownLoadingOnTheWay = 8020,
  HalfWayDownLoadingRefused = 8021,
  HalfWayDownLoadingRefusedPending = 8022,
  HalfWayDownLoadingRefusedOnTheWay = 8023,
  HalfWayDownLoadingSkippedOnTheWay = 8024,
  DeliveryArrive = 8025,
  DeliveryArriveConfirm = 8026,
  DeliveryDownloading = 8027,
  Delivered = 8028,
  DeliveryDownloadingRefused = 8029,
  DeliveryDownloadingRefusedPending = 8030,
  ReturnOnTheWay = 8031,
  SkippedDownloadDelivered = 8032,
  DeliveredReturnOnTheWay = 8033,
  ReturnPointArrive = 8034,
  ReturnPointArriveConfirm = 8035,
  ReturnPointDownloading = 8036,
  ReturnedDelivered = 8037,
  Completed = 8100,
  OnGoing = 8101,
  Pending = 8102,
  CanceledReturnOnTheWay = 8041,
  HalfwayStopArrivalConfirmedWithEndTrip = 8058,
}
